import { render, staticRenderFns } from "./AddBirthdayPopup.vue?vue&type=template&id=5d2f250b"
import script from "./AddBirthdayPopup.vue?vue&type=script&lang=js"
export * from "./AddBirthdayPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports